function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import UnsupportedPermissionError from "./errors/UnsupportedPermissionError.js";
/**
 * Checks permission to use a particular API from: https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API#permission-aware_apis
 * @param permission The name of the permission
 * @returns Promise that resolves to PermissionState on success, or rejects if permission is unsupported by browser
 */
// eslint-disable-next-line import/prefer-default-export
export function checkPermission(_x) {
  return _checkPermission.apply(this, arguments);
}
function _checkPermission() {
  _checkPermission = _asyncToGenerator(function* (permission) {
    try {
      // Typescript doesn't recognize certain permissions as a valid PermissionName
      // https://github.com/microsoft/TypeScript/issues/33923
      var name = permission;
      return (yield navigator.permissions.query({
        name
      })).state;
    } catch (error) {
      // TypeError thrown if retrieving the PermissionDescriptor information failed in some way,
      // or the permission doesn't exist or is unsupported by the user agent.
      if (error instanceof TypeError) {
        throw new UnsupportedPermissionError();
      }
      throw error;
    }
  });
  return _checkPermission.apply(this, arguments);
}
//# sourceMappingURL=PermissionUtils.js.map